/* eslint-disable
    import/no-unresolved,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
require('./clientOverviewLedgers.scss');

const deps = [
  require('angular-ui-router'),
  require('data/dateFilter').name,
  require('data/collection/ledger').name,
  require('data/collection/ledgerWithTransactions').name,
  require('data/collection/ledgerCategory').name,
  require('data/collection/addon').name,
  require('data/collection/categorizerRule').name,
  require('data/model/clientSettings').name,
];

module.exports = angular
  .module('bench.ui.clientOverview.ledgers', deps)

  .directive('blClientOverviewLedgers', () => ({
    restrict: 'E',
    scope: {
      clientId: '=',
    },
    bindToController: true,
    template: require('./clientOverviewLedgers.html'),
    controller: require('./clientOverviewLedgersCtrl.js'),
    controllerAs: 'vm',
  }));
